import {connect} from 'react-redux';
import LocationsPanel from './LocationsPanel.jsx';
import {
  handleCenterChange,
  handleLocationAddClick,
  handleLocationCancelClick,
  handleLocationRemoveClick,
  handleLocationSaveClick,
  handleLocationSearchClick
} from './actions';
import {
  handleLocationNameChange
  } from './actionTypes';

const mapStateToProps = state => ({
  locationName: state.tournament.general.locationName,
  locationSearchResults: state.tournament.general.locationSearchResults,
  locations: state.tournament.general.locations,
  saveable: state.tournament.general.saveable,
  selectable: state.tournament.general.selectable
});

const mapDispatchToProps = dispatch => ({
  onAddLocationClick: () => dispatch(handleLocationAddClick()),
  onCancelClick: () => dispatch(handleLocationCancelClick()),
  onCenterChange: data => dispatch(handleCenterChange(data)),
  onLocationNameChange: data => dispatch(handleLocationNameChange(data)),
  onRemoveClick: data => dispatch(handleLocationRemoveClick(data)),
  onSaveClick: id => dispatch(handleLocationSaveClick(id)),
  onSearchClick: id => dispatch(handleLocationSearchClick(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationsPanel);



// WEBPACK FOOTER //
// ./src/features/tournament/general/LocationsPanelContainer.jsx